import { preloadSpacePages } from '@confluence/space-pages/entry-points/preloadSpacePages.ts';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { isContentTypeEnabledInCurrentEnv } from '@confluence/content-types-utils/entry-points/isContentTypeEnabledInCurrentEnv.ts';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';

export const preloadSpacePagesRoute = async (match: RouteMatch) => {
	const { userId, isLoggedIn, accessStatus, cloudId } = getPreloaderFnContext();
	const { spaceKey } = match.params;
	const isDatabasesEnabled = isContentTypeEnabledInCurrentEnv('database');
	const isWhiteboardsEnabled = isContentTypeEnabledInCurrentEnv('whiteboard');

	const isLicensed =
		accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS ||
		accessStatus === AccessStatus.LICENSED_USE_ACCESS;

	return preloadSpacePages({
		cloudId,
		spaceKey,
		queryParams: match.query,
		userId,
		isLicensed,
		isLoggedIn,
		spaceId: '',
		isWhiteboardEnabled: isWhiteboardsEnabled,
		isDatabaseEnabled: isDatabasesEnabled,
	});
};
